import React from "react";
export const AutoSuggestContext = React.createContext({
    currentValue: "",
});
